import { useEffect } from 'react';
import { useNavigation, Outlet, useLocation, useNavigate } from 'react-router';
import useAuth from 'client/utils/auth/useAuth';
import Navbar from 'client/components/suc/Navbar/Navbar';
import LoadingPage from 'client/pages/LoadingPage/LoadingPage';
import AutoLogout from 'client/components/suc/AutoLogout/AutoLogout';
import LoggedOut from 'client/components/suc/LoggedOut/LoggedOut';
import SystemMessageDisplay from 'client/components/aria/SystemMessageDisplay/SystemMessageDisplay';
import useSystemMessages from 'client/utils/hooks/useSystemMessages';
import { TERMS_AND_CONDITIONS_PAGE } from 'client/utils/routes/routeConstants';

const Layout = ({ children }) => {
    const { user, loading, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const navigation = useNavigation();
    const { pathname } = useLocation();

    const showSpinner = navigation.state === 'loading' || navigation.state === 'submitting' || loading;

    // Load system messages globally for authenticated users only, automatically reloads on route changes
    useSystemMessages({ loadOnMount: !showSpinner && isAuthenticated });

    useEffect(() => {
        if (user?.pendingTermsApproval && pathname !== TERMS_AND_CONDITIONS_PAGE) {
            const redirect = pathname ? `?redirect=${pathname}` : '';
            navigate(TERMS_AND_CONDITIONS_PAGE + redirect);
        }
    }, [user, pathname]);

    return (
        <>
            <Navbar/>
            {
                navigation.state === 'loading' || navigation.state === 'submitting' || loading
                    ? <LoadingPage/>
                    : <>
                        {user && <SystemMessageDisplay/>}
                        <AutoLogout/>
                        <LoggedOut/>
                        <Outlet/>
                        { children }
                    </>
            }
        </>
    );
};

export default Layout;
